import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const CheckoutCancel = () => {
  return (
    <div
      className="bg-[#050505] text-white min-h-[80vh] flex items-center"
      data-testid="checkout-cancel-page"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24">
        <XCircle className="h-14 w-14 text-white/60 mb-6" />
        <div className="font-display text-xs tracking-[0.3em] text-[#D10000] mb-3">
          CHECKOUT CANCELED
        </div>
        <h1
          className="font-display uppercase leading-[0.9] tracking-tight"
          style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)" }}
        >
          No worries.
        </h1>
        <p className="mt-6 text-white/65 max-w-md">
          Your cart is still saved. Pick up right where you left off whenever
          you're ready.
        </p>
        <div className="mt-10 flex gap-3">
          <Link
            to="/shop"
            data-testid="cancel-back-shop-link"
            className="bg-[#D10000] hover:bg-[#A30000] px-6 py-3 font-display tracking-widest uppercase text-sm"
          >
            Back to Shop
          </Link>
          <Link
            to="/"
            data-testid="cancel-home-link"
            className="border border-white/20 hover:border-white px-6 py-3 font-display tracking-widest uppercase text-sm"
          >
            Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
